import { render, staticRenderFns } from "./PublicCollection.vue?vue&type=template&id=3aeb42d4&scoped=true&"
import script from "./PublicCollection.vue?vue&type=script&setup=true&lang=js&"
export * from "./PublicCollection.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeb42d4",
  null
  
)

export default component.exports